/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type WYSIWYGTextareaWithFeatureFlag_organization$ref = any;
type WYSIWYGViewerWithFeatureFlag_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SectionBody_organization$ref: FragmentReference;
declare export opaque type SectionBody_organization$fragmentType: SectionBody_organization$ref;
export type SectionBody_organization = {|
  +constitutionRatifiers: ?string,
  +$fragmentRefs: WYSIWYGViewerWithFeatureFlag_organization$ref & WYSIWYGTextareaWithFeatureFlag_organization$ref,
  +$refType: SectionBody_organization$ref,
|};
export type SectionBody_organization$data = SectionBody_organization;
export type SectionBody_organization$key = {
  +$data?: SectionBody_organization$data,
  +$fragmentRefs: SectionBody_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SectionBody_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "constitutionRatifiers",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WYSIWYGViewerWithFeatureFlag_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WYSIWYGTextareaWithFeatureFlag_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'ffe4f19747cf85eafb20faececfb989e';

module.exports = node;
